import React from 'react'
import BlogHero from './BlogHero';
import BlogLatestPost from './BlogLatestPost';
import BlogTopPost from './BlogTopPost';

const Blog = () => {
    return (
        <>
            <div>
                <BlogHero/>
                <BlogTopPost/>
                <BlogLatestPost/>
            </div>

        </>
    )
}

export default Blog;